<template>
    <div>
        <section class="main-slider">
            <div class="page-header-bg"  style="background-image: url(static/picture/banner/B1.jpg);">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <!-- 产品中心 -->
                    <h1>{{ $t('header.productCenter') }}</h1>
                    <h3>
                        <!-- 硬件产品：通过数字化联网改造... -->
                        <div>{{ $t('productCenter.desc_hardware') }}</div>
                        <!-- 软件产品：针对不同行业传统焊接现状... -->
                        <div>{{ $t('productCenter.desc_software') }}</div>
                    </h3>
                </div>
                <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <!-- 首页 -->
                        <el-breadcrumb-item :to="{ path: 'home' }">{{ $t('header.home') }}</el-breadcrumb-item>
                        <!-- 产品中心 -->
                        <el-breadcrumb-item>{{ $t('header.productCenter') }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>
		<!--软件产品-->
		<section class="welcome-one">
			<div class="container">
                <div class="container__title">
                    <!-- 软件产品 -->
                    <span>{{ $t('productCenter.section_software_title') }}</span>
                </div>
                <!-- 行业软件 -->
                <div class="row" v-if="softwareParams && softwareParams.industryList.length">
                    <div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <!-- 焊接软件 -->
                            <h4 >{{ $t('header.weldingSoftware') }}</h4>
                        </div>
                    </div>

                  
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" v-for="(item,index) in softwareParams.industryList" :key="index" @click="handleDetail(item,index)" :data-wow-delay="(index+1)+'ms'" >
                        <div class="feature-one__single">
                            <div class="feature-one__img">
                                <!--  src="static/picture/feature-1-3.jpg" -->
                                <img :src="item.pictureUrl"  alt="">
                                <div class="feature-one__title-box">
                                    <h3 class="feature-one__title feature-one__title_omit" v-if="isShow">
                                        <!-- {{ item.title }} -->
                                         {{ $t(`productCenter.${item.i18n_title}`) }}
                                    </h3>
									<div style="font-size: 18px;margin-top: 5px;color: #fff;font-weight: bold;">{{ item.title_abb }}</div>
								</div>
                                <div class="feature-one__hover-content">
                                  
                                    <h3 class="feature-one__hover-title feature-one__title_omit" v-if="isShow">
                                        <!-- {{ item.title }} -->
                                           <span>{{ $t(`productCenter.${item.i18n_title}`) }}</span>
                                    </h3>
									
                                    <p class="feature-one__hover-text">
                                        <!-- {{ item.text }} -->
                                         {{ $t(`productCenter.${item.i18n_text}`) }}
                                    </p>
                                    <div class="feature-one__learn-more">
                                        <!-- 查看 -->
                                        {{ $t('productCenter.action_view') }}<i class="fa fa-long-arrow-alt-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 <!-- 专业软件 -->
                 <div class="row" v-if="softwareParams && softwareParams.specialityList.length">
                    <div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <!-- 专业软件 -->
                            <h4 >{{ $t('header.professionalSoftware') }}</h4>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" v-for="(item,index) in softwareParams.specialityList" :key="index" @click="handleDetail(item,index)" :data-wow-delay="(index+1)+'ms'" >
                        <div class="feature-one__single">
                            <div class="feature-one__img">
                                <!--  src="static/picture/feature-1-3.jpg" -->
                                <img :src="item.pictureUrl"  alt="">
                                <div class="feature-one__title-box">
                                    <h3 class="feature-one__title feature-one__title_omit" v-if="isShow">
                                        <!-- {{ item.title }} -->
                                        {{ $t(`productCenter.${item.i18n_title}`) }}
                                    </h3>
									<div style="font-size: 18px;margin-top: 5px;color: #fff;font-weight: bold;">{{ item.title_abb }}</div>
								</div>
                                <div class="feature-one__hover-content">
                                  
                                    <h3 class="feature-one__hover-title feature-one__title_omit" v-if="isShow">
                                        <!-- {{ item.title }} -->
                                           {{ $t(`productCenter.${item.i18n_title}`) }}
                                    </h3>
                                    <p class="feature-one__hover-text">
                                        <!-- {{ item.text }} -->
                                         {{ $t(`productCenter.${item.i18n_text}`) }}
                                    </p>
                                    <div class="feature-one__learn-more">
                                        <!-- 查看 -->
                                        {{ $t('productCenter.action_view') }}<i class="fa fa-long-arrow-alt-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 <!--移动软件 -->
                <div class="row" v-if="softwareParams &&softwareParams.moveList.length">
                    <div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <!-- 移动软件 -->
                            <h4 >{{ $t('header.mobileSoftware') }}</h4>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" v-for="(item,index) in softwareParams.moveList" :key="index" @click="handleDetail(item,index)" :data-wow-delay="(index+1)+'ms'" >
                        <div class="feature-one__single">
                            <div class="feature-one__img">
                                <!--  src="static/picture/feature-1-3.jpg" -->
                                <img :src="item.pictureUrl"  alt="">
                                <div class="feature-one__title-box">
                                    <h3 class="feature-one__title feature-one__title_omit" v-if="isShow">
                                        <!-- {{ item.title }} -->
                                          {{ $t(`productCenter.${item.i18n_title}`) }}
                                    </h3>
									<div style="font-size: 18px;margin-top: 5px;color: #fff;font-weight: bold;">{{ item.title_abb }}</div>
                                </div>
                                <div class="feature-one__hover-content">
                                  
                                    <h3 class="feature-one__hover-title feature-one__title_omit" v-if="isShow">
                                        <!-- {{ item.title }} -->
                                         {{ $t(`productCenter.${item.i18n_title}`) }}
                                    </h3>
                                    <p class="feature-one__hover-text">
                                        <!-- {{ item.text }} -->
                                         {{ $t(`productCenter.${item.i18n_text}`) }}
                                    </p>
                                    <div class="feature-one__learn-more">
                                        <!-- 查看 -->
                                        {{ $t('productCenter.action_view') }}<i class="fa fa-long-arrow-alt-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
		</section>

        <!--硬件产品-->
		<section class="welcome-three">
			<div class="container">
                <div class="container__title">
                    <!-- 硬件产品 -->
                    <span>{{ $t('productCenter.section_hardware_title') }}</span>
                </div>
                    <!-- 智能终端 -->
                <div class="row" v-if="hardwareParams && hardwareParams.terminalList.length">
                    <div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <!-- 智能终端 -->
                            <h4 >{{ $t('header.intelligentTerminal') }}</h4>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" v-for="(item,index) in hardwareParams.terminalList" :key="index" @click="handleHardware(item,index)" :data-wow-delay="(index+1)+'ms'" >
                        <div class="feature-one__single hardware_bg">
                            <div class="feature-one__img">
                                <!--  src="static/picture/feature-1-3.jpg" -->
                                <img :src="item.pictureUrl"  alt="">
                                <div class="feature-one__title-box">
                                    <h3 class="feature-one__title feature-one__title_omit" v-if="isShow">
                                        <!-- {{ item.title_zh }} -->
                                        {{ $t(`productCenter.${item.i18n_title_zh}`) }}
                                    </h3>
									<div style="font-size: 18px;margin-top: 5px;color: #fff;font-weight: bold;">
                                        <!-- {{ item.title_en }} -->
                                         {{ $t(`productCenter.${item.i18n_title_en}`) }}
                                    </div>
                                </div>
                                <div class="feature-one__hover-content">
                                  
                                    <h3 class="feature-one__hover-title feature-one__title_omit" v-if="isShow">
                                        <!-- {{ item.title }} -->
                                         {{ $t(`productCenter.${item.i18n_title}`) }}
                                    </h3>
                                    <p class="feature-one__hover-text">
                                        <!-- {{ item.text }} -->
                                        {{ $t(`productCenter.${item.i18n_text}`) }}
                                    </p>
                                    <div class="feature-one__learn-more">
                                        <!-- 查看 -->
                                        {{ $t('productCenter.action_view') }}<i class="fa fa-long-arrow-alt-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  
                </div>
                <!-- 焊接网关- 二、焊接工业互联网关-->
                <div class="row" v-if="hardwareParams &&hardwareParams.weldingGatewayList.length">
                    <div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <!-- 焊接工业互联网网关 -->
                            <h4 >{{ $t('header.industrialGateway') }}</h4>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" v-for="(item,index) in hardwareParams.weldingGatewayList" :key="index" @click="handleHardware(item,index)" :data-wow-delay="(index+1)+'ms'" >
                        <div class="feature-one__single hardware_bg">
                            <div class="feature-one__img">
                                <!-- :src="item.pictureUrl" src="static/picture/feature-1-3.jpg" @/assets/product/ATQ-IT070.jpg -->
                                <!-- :src="require('../../assets/product/'+item.pictureUrl)" -->
                                <img  :src="item.pictureUrl"  alt="">
                                <div class="feature-one__title-box">
                                    <h3 class="feature-one__title feature-one__title_omit" v-if="isShow">
                                        <!-- {{ item.title_zh }} -->
                                        {{ $t(`productCenter.${item.i18n_title_zh}`) }}
                                    </h3>
									<div style="font-size: 18px;margin-top: 5px;color: #fff;font-weight: bold;">
                                        <!-- {{ item.title_en }} -->
                                        {{ $t(`productCenter.${item.i18n_title_en}`) }}
                                    </div>
                                </div>
                                <div class="feature-one__hover-content">
                                  
                                    <h3 class="feature-one__hover-title feature-one__title_omit" v-if="isShow">
                                        <!-- {{ item.title }} -->
                                         {{ $t(`productCenter.${item.i18n_title}`) }}
                                    </h3>
                                    <p class="feature-one__hover-text">
                                        <!-- {{ item.text }} -->
                                          {{ $t(`productCenter.${item.i18n_text}`) }}
                                    </p>
                                    <div class="feature-one__learn-more">
                                        <!-- 查看 -->
                                        {{ $t('productCenter.action_view') }}<i class="fa fa-long-arrow-alt-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 <!-- 机器人网关--焊接机器人网关 -->
                 <div class="row" v-if="hardwareParams && hardwareParams.robotGatewayList.length">
                    <div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <!-- 焊接机器人网关 -->
                            <h4 >{{ $t('header.robotGateway') }}</h4>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" v-for="(item,index) in hardwareParams.robotGatewayList" :key="index" @click="handleHardware(item,index)" :data-wow-delay="(index+1)+'ms'" >
                        <div class="feature-one__single hardware_bg">
                            <div class="feature-one__img">
                                <!--  src="static/picture/feature-1-3.jpg" -->
                                <img :src="item.pictureUrl"  alt="">
                                <div class="feature-one__title-box">
                                    <h3 class="feature-one__title feature-one__title_omit" v-if="isShow">
                                        <!-- {{ item.title_zh }} -->
                                         {{ $t(`productCenter.${item.i18n_title_zh}`) }}
                                    </h3>
									<div style="font-size: 18px;margin-top: 5px;color: #fff;font-weight: bold;">
                                        <!-- {{ item.title_en }} -->
                                        {{ $t(`productCenter.${item.i18n_title_en}`) }}
                                    </div>
                                </div>
                                <div class="feature-one__hover-content">
                                  
                                    <h3 class="feature-one__hover-title feature-one__title_omit" v-if="isShow">
                                        <!-- {{ item.title }} -->

                                        {{ $t(`productCenter.${item.i18n_title}`) }}
                                    </h3>
                                    <p class="feature-one__hover-text">
                                        <!-- {{ item.text }} -->
                                          {{ $t(`productCenter.${item.i18n_text}`) }}
                                    </p>
                                    <div class="feature-one__learn-more">
                                        <!-- 查看 -->
                                        {{ $t('productCenter.action_view') }}<i class="fa fa-long-arrow-alt-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
             
                 <!-- 其他设备设备 -->
                 <div class="row" v-if="hardwareParams && hardwareParams.otherList.length">
                    <div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <!-- 其他设备 -->
                            <h4 >{{ $t('header.otherDevices') }}</h4>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" v-for="(item,index) in hardwareParams.otherList" :key="index" @click="handleHardware(item,index)" :data-wow-delay="(index+1)+'ms'" >
                        <div class="feature-one__single hardware_bg">
                            <div class="feature-one__img">
                                <!--  src="static/picture/feature-1-3.jpg" -->
                                <img :src="item.pictureUrl"  alt="">
                                <div class="feature-one__title-box">
                                    <h3 class="feature-one__title feature-one__title_omit" v-if="isShow">
                                        <!-- {{ item.title_zh }} -->
                                        {{ $t(`productCenter.${item.i18n_title_zh}`) }}
                                    </h3>
									<div style="font-size: 18px;margin-top: 5px;color: #fff;font-weight: bold;">
                                        <!-- {{ item.title_en }} -->
                                         {{ $t(`productCenter.${item.i18n_title_en}`) }}
                                    </div>
                                </div>
                                <div class="feature-one__hover-content">
                                  
                                    <h3 class="feature-one__hover-title feature-one__title_omit" v-if="isShow">
                                        <!-- {{ item.title }} -->
                                        {{ $t(`productCenter.${item.i18n_title}`) }}
                                    </h3>
                                    <p class="feature-one__hover-text">
                                        <!-- {{ item.text }} -->
                                         {{ $t(`productCenter.${item.i18n_text}`) }}
                                    </p>
                                    <div class="feature-one__learn-more">
                                        <!-- 查看 -->
                                        {{ $t('productCenter.action_view') }}<i class="fa fa-long-arrow-alt-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
		</section>
    </div>
</template>

<script >

import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'list',
     mixins: [MixinsList],
    components: {

    },
    data () {
        return {
            routeList: [],  // 面包屑
            softwareParams: null,
            hardwareParams: null,
           
        }
    },
    created() {
		
        this.getList()  // 获取内容
    },
    mounted () {
       
         // 确定选中的菜单
        $('.current').removeClass('current');  
        $('.product_li').addClass('current');
    },
    methods: {
        // 获取内容
       async getList() {
            // const { software, hardware } = res.result
            try {
            const  { software, hardware }  = await loadData('productList', this.lang)
            this.softwareParams = JSON.parse(JSON.stringify(software))  // 软件产品
            this.hardwareParams = JSON.parse(JSON.stringify(hardware))  // 硬件产品
            } catch (error) {
                 console.error('[productList] 加载失败:', error)
                this.softwareParams = {}
                this.hardwareParams = {}
             }
       
        },
        // 查看软件产品
        handleDetail(item, index) {
            if(item.path && item.type) {
                this.$router.push({
                    path: item.path,
                    query: {
                        type: item.type
                    }
                });
            } else {
                // 暂时无法查看！
                this.$message.warning(this.$t('productCenter.msg_temp_unavailable'));
            }
        },
        // 查看硬件
        handleHardware(item, index) {
            if(item.path) {
                this.$router.push({
                    path: item.path,
                    query: {
                        type: item.type
                    }
                });
            } else {
                // 暂时无法查看！
                this.$message.warning(this.$t('productCenter.msg_temp_unavailable'));
            }
        }
    }
}
</script>
<style scoped>
.page-header-bg {
    background-color: transparent; 
}
.page-header__inner h1 {
    font-size: var(--font-size-40);
}
/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    /* color: var(--notech-primary) !important; */
    color: var(--notech-white);
    font-size: var(--font-size-16);
    font-weight: 700;
    transition: all 500ms ease;
}

.welcome-one {
    background: var(--notech-extra);
   padding: 60px 0 0; 
}
.welcome-three {
    background: var(--notech-extra);
   padding: 60px 0 120px; 
}
.container__title {
    font-size: var(--font-size-40);
    line-height: 50px;
    text-align: center;
    color: #232e5e;
}
.row__title {
    padding-left: 30px;
    margin-bottom: 15px;
    line-height: 1.65;
    position: relative;
}
.row__title h4 {
    font-size: var(--font-size-30);
    line-height: 50px;
    color: #232e5e;
}
.row__title h4::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    width: 4px;
    height: 27px;
    background-color: var(--notech-base);
    border-radius: 2px;
}
.feature-one__title-box {
    position: absolute;
    left: 50px;
    bottom: 20px;
    opacity: 1;
    visibility: visible;
    transition: all 500ms ease;
    z-index: 5;
}
.feature-one__title-box {
    left: 30px;
    right: 30px;
}

.feature-one__single {
    cursor: pointer;
}
.feature-one__img img {
    height: 300px;
   
}
.feature-one__title_omit {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.feature-one__title {
   
    font-size: var(--font-size-20);
    color: var(--notech-white);
    /* color: #232e5e; */
} 
.feature-one__hover-title {
    font-size: var(--font-size-20);
    color: var(--notech-white);
    transition: all 500ms ease;
} 
.feature-one__learn-more {
    position: relative;
    display: flex;
    align-items: center;
    font-size: var(--font-size-16);
    color: var(--notech-base);
    font-weight: 700;
    transition: all 500ms ease;
} 
.feature-one__learn-more i {
    position: relative;
    padding-left: 10px;
    top: 2px;
}
.feature-one__hover-text {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

/* 硬件产品的背景颜色 */
.hardware_bg {
    /* background: var(--notech-bdr-color) */
    background:  #1748a4;
}
</style> 